/**
 * Status-name BC-shim for history records.
 *
 * The v2 backend dictionary moved from the legacy verbs (`completed` /
 * `success` / `failed`) to the new one (`confirmed` / `cancelled`)
 * around backend 1.4. Mobile clients see both because:
 *   - Newly written rows carry the new vocabulary.
 *   - Historical rows still hold the old strings.
 *   - The OneAdmin "Statuses" reference page tolerates both for the
 *     foreseeable future.
 *
 * History screens (current account / deposit / all-history) display
 * only "confirmed" rows. To keep that filter robust across the BC
 * window we accept any of the three legacy synonyms as "confirmed".
 *
 * Case-insensitive — backend has historically mixed `Confirmed` and
 * `confirmed`, and incoming rows are not strictly normalised.
 */
export const isConfirmedStatus = (
  statusName: string | null | undefined,
): boolean => {
  const s = (statusName ?? '').toLowerCase().trim();
  return s === 'confirmed' || s === 'completed' || s === 'success';
};
